<template>
  <PlatDataPanelSelect class="teaching-schedule-paper"
                       :custom-id="customId"
                       :data-types="['semester', 'site']"
                       semesterLabel="选择学期"
                       siteLabel="选择教学点">
    <template #default="scope">
      <keep-alive>
        <TemplateDataGrid :key="`${scope.semester}:${scope.site}`"
                          gridId="PeTchSchedulePaper"
                          v-bind="scope"></TemplateDataGrid>
      </keep-alive>
    </template>
  </PlatDataPanelSelect>
</template>

<script>
import PlatDataPanelSelect from '../../../wrapper/panel/PlatDataPanelSelect'
import TemplateDataGrid from '../../../../../../templates/TemplateDataGrid'
import routeConfig from '../../../../../../../constants/routeConfig'
export default {
  name: 'TeachingSchedulePaper',
  components: {
    PlatDataPanelSelect,
    TemplateDataGrid
  },
  data () {
    return {
      customId: ''
    }
  },
  created () {
    this.customId = this.$route.params[routeConfig.DataTile.param]
  }
}
</script>

<style lang="scss">
  .teaching-schedule-paper {
    height: 100%;
  }
</style>
